/**
 * Creates product filter entries for CompanyFilter
 *
 * @param productIds Array of product IDs to include
 * @param inclusionMethod Method to determine inclusion (ANY_PRESENT, ALL_PRESENT, or NONE_PRESENT)
 * @returns Product filter object
 */
export const createProductFilter = (
  productIds: number[],
  inclusionMethod:
    | "ANY_PRESENT"
    | "ALL_PRESENT"
    | "NONE_PRESENT" = "ANY_PRESENT"
) => ({
  ids: productIds,
  inclusionMethod,
  roleIds: [],
  departmentIds: [],
});
